var defaultAnalytics = {
  value: 'Popover',
  actions: {
    onRequestClose: {
      type: 'POPOVER_ON_REQUEST_CLOSE',
      payload: 'Close'
    }
  }
};

export default defaultAnalytics;
